/**
 * Resale Pricing → Rounding Rules tab. Placeholder until the feature is
 * designed — explains what will live here so the tab isn't a dead end.
 */
import { Title } from 'react-admin';
import { Box, Chip, Stack, Typography } from '@mui/material';
import ExposureIcon from '@mui/icons-material/Exposure';

import { useTitle } from '@src/hooks/useTitle';
import { ResalePricingTabShell } from './shared';

const RoundingRulesPage = () => {
  const { title } = useTitle('Resale Pricing · Rounding Rules');

  return (
    <ResalePricingTabShell tab="roundingRules">
      <Title title={title} />
      <Box
        sx={{
          mt: 1.5,
          border: '1px dashed',
          borderColor: 'divider',
          borderRadius: 1,
          bgcolor: 'background.paper',
          px: 3,
          py: 8,
          textAlign: 'center',
        }}
      >
        <ExposureIcon sx={{ fontSize: 40, color: 'grey.400' }} />
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" sx={{ mt: 1.5 }}>
          <Typography variant="h6" sx={{ fontSize: 16 }}>
            Rounding Rules
          </Typography>
          <Chip size="small" variant="outlined" label="Coming soon" />
        </Stack>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1, maxWidth: 480, mx: 'auto' }}>
          Configure how calculated resale prices round before they reach the storefront —
          for example, always ending in .95, or rounding down to the nearest dollar.
          Rounding currently follows your program defaults; contact your Trove
          representative to change them.
        </Typography>
      </Box>
    </ResalePricingTabShell>
  );
};

export default RoundingRulesPage;
